import { useReducer } from 'react';
import { FsRawNode } from '~/api/types';
import { getFilesInFolder } from '~/pages/StoragePage/utils';

const reducer = (state: FsRawNode[] | null, folder: FsRawNode | null) => {
  if (!folder) return state;

  return getFilesInFolder(folder);
};

const useFilesToDisplayState = (initialFolder: FsRawNode | null) =>
  useReducer(reducer, getFilesInFolder(initialFolder));

export default useFilesToDisplayState;
